const Delete = (url, body) =>
    new Promise((resolve, reject) => {
        var req = {
            method: "DELETE"
        };
        if (body) {
            req.body = JSON.stringify(body);
            req.headers = { "Content-Type": "application/json" };
        }

        return fetch(url, req)
            .then((response) => {
                response
                    .json()
                    .then(response.ok ? resolve : reject)
                    .catch(reject);
            })
            .catch(reject);
    });

export default Delete;